import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { BriefingPreviewDialogComponent } from './briefingPreviewDialog.component';

@Component({
    selector: 'briefing-editor',
    template: `
        <div style="height: calc(100vh - 132px); overflow-y: auto;">
                    <div *ngIf="briefingId && !remoteTypes.includes(form.get('type').value)" fxLayout="row">
                        <span fxFlex></span>
                        <button mat-button color="primary" (click)="preview()">Preview</button>
                    </div>
                    <mat-tab-group>
                        <mat-tab label="Settings" *ngIf="form.get('type').value === 'TEAMS'">
                            <briefing-teams-settings-editor [form]="form" [briefingId]="briefingId"></briefing-teams-settings-editor>
                        </mat-tab>
                        <mat-tab label="Settings" *ngIf="form.get('type').value === 'SLACK'">
                            <briefing-slack-settings-editor *ngIf="form" [form]="form"></briefing-slack-settings-editor>
                        </mat-tab>
                        <mat-tab label="Settings" *ngIf="!remoteTypes.includes(form.get('type').value)">
                            <ng-template matTabContent>
                                <briefing-settings-editor *ngIf="form" [form]="form"></briefing-settings-editor>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="Schedule">
                            <briefing-schedule-editor *ngIf="form" [form]="form.get('schedule')" [briefingId]="briefingId"></briefing-schedule-editor>
                        </mat-tab>
                        <mat-tab label="People" *ngIf="briefingId && !remoteTypes.includes(form.get('type').value)">
                            <briefing-members [briefingId]="briefingId"></briefing-members>
                        </mat-tab>
                        <mat-tab label="Topics">
                            <briefing-topics-editor *ngIf="form" 
                                                    [topic$]="topic$"
                                                    (reorderTopics)="reorderTopics.emit($event)" 
                                                    (saveTopics)="saveTopics()"
                                                    [type]="form.get('type').value">
                            </briefing-topics-editor>
                        </mat-tab>
                        <mat-tab label="History" *ngIf="briefingId">
                            <briefing-history [briefingId]="briefingId" [type]="form.get('type').value"></briefing-history>
                        </mat-tab>
                        <mat-tab label="Groups" *ngIf="briefingId && !remoteTypes.includes(form.get('type').value)">
                            <briefing-groups *ngIf="form" [briefingId]="briefingId"></briefing-groups>
                        </mat-tab>
                    </mat-tab-group>
        </div>
    `
})
export class BriefingEditorComponent {
    @Input() briefingId: string;
    @Input() form: FormGroup;
    @Input() originalBriefing: any;
    @Input() topic$: BehaviorSubject<any[]>;
    @Output() save = new EventEmitter<boolean>();
    @Output() reorderTopics = new EventEmitter<{ currentIndex: number, previousIndex: number}>();

    remoteTypes = ['SLACK', 'TEAMS'];

    constructor(private dialog: MatDialog) {}

    saveTopics(): void {
        if (this.briefingId) {
            this.save.emit(true);
        }
    }

    preview():void {
        this.dialog.open(BriefingPreviewDialogComponent, { data: { briefingId: this.briefingId } });
    }
}